import React, { useState } from 'react'
import { MDBInput } from 'mdbreact';
import axios from 'axios';

const EditarInventario = ({ productoSelecionadoActualizar, setFuncion, baseUrl }) => {
    const [registro, setRegistro] = useState(productoSelecionadoActualizar)
    const [alerta, setAlerta] = useState()

    const actualizarInventario = async e => {
        e.preventDefault()
        try {
            const { cantidad, costo, id } = registro;
            if (cantidad == "0") return setAlerta(true)

            let formData = new FormData()

            formData.append('cantidad', cantidad)
            formData.append('costo', 0)
            formData.append('id', id)
            formData.append('METHOD', 'PUT')
            const { data } = await axios.post(baseUrl, formData)
            setFuncion('ver')
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <form onSubmit={actualizarInventario}>
            <h4>Actualizar Inventario</h4>
            <hr />

            <MDBInput
                label={`Cantidad`}
                value={registro.cantidad}
                onChange={e => setRegistro({ ...registro, cantidad: e.target.value })}
                name="cantidad"
                required
                outline />



            {alerta ? <p className="error">¡Llena todos los campos o la Cantidad o costo deben ser mayor a 0!!</p> : <span></span>}

            <div className="col text-center">
                <button
                    type='submit'
                    className="btn boton_estandar"
                >Actualizar Ingrediente
                </button>
                <button
                    onClick={e => setFuncion('ver')}
                    className="btn boton_estandar"
                >Cancelar
                </button>
            </div>
        </form>
    )
}

export default EditarInventario